var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VSwitch',_vm._g(_vm._b({class:_vm.classList},'VSwitch',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }